import React from 'react';
import { useTranslation } from 'react-i18next';

import Booking from '../../../core/types/model/Booking';
import { BookingSortFilter } from '../types';

import THead from '../../../components/table/THead/THead';
import TR from '../../../components/table/TR/TR';
import TH from '../../../components/table/TH/TH';
import InteractiveElement from '../../../components/interactive-element/InteractiveElement';
import Icon from '../../../components/icon/Icon';

interface Props {
  sortFilter: keyof Booking;
  isSortAscending: boolean;
  handleSorting: (column: BookingSortFilter) => void;
}

const ProjectListingHeader: React.FC<Props> = ({ sortFilter, isSortAscending, handleSorting }) => {
  const { t } = useTranslation();

  const getHeadingIconClass = (type: BookingSortFilter) => {
    return `project-listing__header-icon ${type === sortFilter && !isSortAscending ? 'project-listing__header-icon--desc' : ''} ${
      type === sortFilter ? 'project-listing__header-icon--active' : ''
    }`;
  };

  return (
    <THead>
      <TR>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting('title')} isDiv>
            <span>{t('booking.booking')}</span>
            <Icon className={getHeadingIconClass('title')} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting('date')} isDiv>
            <span>{t('common.date')}</span>
            <Icon className={getHeadingIconClass('date')} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting('startTime')} isDiv>
            <span>{t('common.time')}</span>
            <Icon className={getHeadingIconClass('startTime')} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting('deliveryZoneId')} isDiv>
            <span>{t('booking.deliveryZone')}</span>
            <Icon className={getHeadingIconClass('deliveryZoneId')} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting('transportEquipmentId')} isDiv>
            <span className="d-print-none">{t('booking.description')}</span>
            <span className="d-print-block d-none">{t('booking.delItem')}</span>
            <Icon className={getHeadingIconClass('transportEquipmentId')} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
        <TH>
          <span>{t('common.vehicle')}</span>
        </TH>
        <TH>
          <span className="d-print-none">{t('booking.contactPersonSubcontractor')}</span>
          <span className="d-print-block d-none">{t('common.contactPerson')}</span>
        </TH>
        <TH>
          <span className="d-print-none">{t('booking.accessCode')}</span>
          <span className="d-print-block d-none">{t('booking.acCode')}</span>
        </TH>
        <TH>
          <span>{t('common.status')}</span>
        </TH>
        <TH />
      </TR>
    </THead>
  );
};

export default ProjectListingHeader;
